export default __webpack_public_path__ + "static/media/Illustration.2be915e9.png";